import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import ProgramShop from 'src/components/ProgramShop';

interface Props {
  id: number;
}

const ProgramPurchase: NextPage<Props> = ({ id }) => {
  return <ProgramShop programId={id} />;
};

export const getServerSideProps: GetServerSideProps<Props> = async ({
  query,
}) => {
  const programId = query.programId as string;
  const id = programId ? Number(programId) : undefined;
  if (!id || typeof id !== 'number') {
    return {
      notFound: true,
    };
  }
  return {
    props: {
      id,
    },
  };
};

export default ProgramPurchase;
